
import SEOHead from '../../components/seo/SEOHead';
import TrustHeroSection from './components/TrustHeroSection';
import TrustSystemSection from './components/TrustSystemSection';
import QualityControlSection from './components/QualityControlSection';
import CertificationSection from './components/CertificationSection';

export default function Trust() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "年份茶信任体系",
    "description": "顺年陈独创的年份茶信任体系，通过透明化、数据化、可视化三大维度，确保真产地、真年份、真转化。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/trust`,
    "mainEntity": {
      "@type": "Service",
      "name": "年份茶信任体系",
      "description": "透明化体系、数据化标准、可视化体验",
      "provider": {
        "@type": "Organization",
        "name": "顺年陈"
      }
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="年份茶信任体系 - 顺年陈透明化标准"
        description="顺年陈独创的年份茶信任体系，通过透明化、数据化、可视化三大维度，确保真产地、真年份、真转化。建立行业新标准。"
        keywords="年份茶信任体系,透明化,数据化,可视化,真产地,真年份,真转化,顺年陈"
        canonical="/trust"
        structuredData={structuredData}
      />
      <TrustHeroSection />
      <TrustSystemSection />
      <QualityControlSection />
      <CertificationSection />
    </div>
  );
}
